module.exports = __webpack_public_path__ + "static/media/Samsung.dc71bbaa.jpg";